import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { AutocompleteInput, Create, FormDataConsumer, SelectInput, SimpleForm, TextInput, required, useDataProvider } from 'react-admin';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import YouTubeInput from '../../common/YoutubeInput';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

export const CategoryRender = (choice: any) => `${choice.name}`;
const getYouTubeEmbedCode = (data: any): string => {
  const url = `https://www.youtube.com/embed/${data.VideoUrl}`;
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v=|v\/|.+\?v=)|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  const code = match ? match[1] : '';
  return data.Thumbnail || `https://i.ytimg.com/vi/${code}/hq720.jpg`;
};

const DemoVideoCreate = () => {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('demoVideoCategoryId');
  const dataProvider = useDataProvider();
  const isDisabled = !!categoryId;
  const [categories, setCategories] = useState([]) as any;

  useEffect(() => {
    dataProvider
      .getList('demo-video-categories', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'name', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => setCategories(data))
      .catch((error) => console.error(error));
  }, [dataProvider]);

  return (
    <Create
      transform={(data: any) => ({
        ...data,
        Thumbnail: getYouTubeEmbedCode(data),
        VideoUrl: `https://www.youtube.com/embed/${data.VideoUrl}`,
        VideoId: null,
      })}
      redirect={'/demo-videos'}
      resource="demo-videos"
    >
      <SimpleForm
        defaultValues={{
          DemoVideoCategoryId: categoryId
        }}
      >
        <TextInput source="title" fullWidth validate={[required(), validateNotEmpty]} />
        <SlugInput source="slug" fullWidth validate={[required(), validateNotEmpty]} />
        <YouTubeInput source="videoUrl" />
        <HTMLEditorInput
          source="description"
          fullWidth
          validate={[required(), validHtml]}
        />
        <AutocompleteInput
          source="demoVideoCategoryId"
          choices={categories}
          optionText={CategoryRender}
          fullWidth
          isRequired
          disabled={isDisabled}
        />
      </SimpleForm>
    </Create>
  );
};
export default DemoVideoCreate;